import React, { Fragment, FunctionComponent, useEffect, useState} from "react";
import { useSelector } from "react-redux";
import { Button } from "@progress/kendo-react-buttons";
import {
    ComboBox,
    DropDownList,
    ComboBoxChangeEvent,
    ComboBoxFilterChangeEvent,
    DropDownListChangeEvent,
    MultiSelect,
    MultiSelectChangeEvent,
    MultiSelectFilterChangeEvent,
} from "@progress/kendo-react-dropdowns";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

import Format from "../Common/Util_methods/formatParamOptions";
import { defaultDate, defaultDateStrings, max, min } from "../Common/Constants";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { filterBy } from "@progress/kendo-data-query";
import { getDevicesSelector, loadingDevicesSelector } from "../Devices/Slice";
import Spinner from "../Common/Components/spinner";
import { mdcApi } from "../MDC/mdcApi";
import {
    DecadeCalendar,
    YearCalendar,
} from "../Common/Components/CustomCalendar";

import { updateParams, getParamsSelector, initialState, Params} from "../Common/Slices/ParamSlice";
import { useAppDispatch } from "../Core/store.hooks";
import {difference, groupBy, identity, isEmpty,isEqual, property} from "lodash";
import {useParams } from 'react-router-dom';
import getQueryStringParams from "../Common/Util_methods/queryString";
import { getOptionsSelector, updateOptionsScopeOrder } from "../Common/Slices/optionSlice";
import { push } from 'react-router-redux';
import { updateSliceBucketSize } from "../RunningPeriods/runningPeriodsOptionSlice";
import { RootState } from "../Core/Store";
import { determineScope } from "../Common/Util_methods/scope";
import { useLocation } from 'react-router-dom';
import { Api } from "./Api";


interface FilterProps {
    id: string;
    countryInput?:boolean|"required";
    deviceTypeInput?:boolean|"required";
    customerInput?:boolean|"required";
    deviceWithSerialInput?:boolean|"hidden"|"required";
    scopeOrderInput?:boolean;
    groupByInput?:boolean;
    devicesFromMultipleCustomers?: boolean;
    updateParams: any;
}

const Filters: FunctionComponent<FilterProps> = (props) => {

    const defaultStart = new Date(2000, 0, 1);
    const queryparams = useParams();
    let urlParams = getQueryStringParams(queryparams.queryparams);
    
    const deviceLoadState = useSelector(loadingDevicesSelector);
    const deviceObjects = useSelector(getDevicesSelector);

    const globalParams = useSelector<RootState,Params>(getParamsSelector);

    const options = useSelector(getOptionsSelector);
    const dispatch = useAppDispatch();

    const [assemblys, updateAssemblys] = useState([]);
    const [components, updateComponents] = useState([]);
    const [descriptions, updateDescriptions] = useState([]);

    const [allDescriptions, updateAllDescriptions] = useState([]);
    const [descriptionsOG, updateDescriptionsOG] = useState([]);
    const [selectedAssembly, updateSelectedAssembly] = useState(null);
    const [selectedComponent, updateSelectedComponent] = useState(null);
    const [selectedDescription, updateSelectedDescription] = useState(null);
    const [headerLoadingState, updateHeaderLoadingState] = useState(false);
    const [selectedUnit, updateSelectedUnit] = useState(null);
    const [unitsLoading, setUnitsLoading] = useState(false);
    const [units, updateUnits] = useState([]);


    const [countries, updateCountries] = useState([]);
    const [customers, updateCustomers] = useState([]);
    const [deviceTypes, updateDeviceTypes] = useState([]);
    const [devicesWithSerial, updateDevicesWithSerial] = useState([]);

    const [country, updateCountry] = useState(null);
    const [customer, updateCustomer] = useState(null);
    const [selectedDeviceTypes, updateSelectedDeviceTypes] = useState([]);
    const [selectedDevicesWithSerial, updateSelectedDevicesWithSerial] = useState([]);
    const scopes = ["Customer > Machine","Country > Customer > Machine","Device Type > Customer > Machine","Device Type > Country > Customer > Machine","Device Type > Machine"];
    const [scopeOrder, updateScopeOrder] = useState(scopes[0]);
    const [dialogVisible, setDialogVisible] = useState(false);
    const [descriptionStrings, updateDescriptionStrings]= useState([]);

    const [start, setStart] = useState(defaultStart);
    const [end, setEnd] = useState(defaultDate.end);

    const [urlParamsDone, setUrlParamsDone] = useState(false)
    const [globalParamsDone, setGlobalParamsDone] = useState(false);
    const location = useLocation();
    // useEffect(() => {
    //     if(isEmpty(urlParams) && isEqual(globalParams,initialState) && urlParamsDone===false){
    //         paramsHandler();
    //     }
    //     dispatch(updateSliceBucketSize(bucketSize))
    // }, []);
    useEffect(() => {
        if (urlParamsDone === true) {
            if (selectedDescription != null) {
                paramsHandler()
            }
           
        }
    }, [urlParamsDone]);

    //useEffect(()=>{
    //    if(globalParamsDone === true){
    //        paramsHandler()
    //    }
    //},[globalParamsDone])


    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;
        fetchDescriptions(signal);

            //updateSelectedComponent(null);
            //updateSelectedDescription(null);
        
        return () => controller.abort();
      
    },[customer,selectedDeviceTypes])


    useEffect(() => {
        if (selectedDescription != null) {
            updateUnits([]);
            updateSelectedUnit(null);
            getUnits();
        }
        else {
            updateUnits([]);
            updateSelectedUnit(null);
        }
    }, [selectedDescription]);



    useEffect(() => {
        
        updateDropDowns();
        if(!isEmpty(urlParams)&&deviceObjects.length >0){
            updateFiltersWithUrlParams()
            setUrlParamsDone(true)
            //clear url
            dispatch(push("/" + location.pathname.split("/")[1]))
        }else{
            updateFiltersWithGlobalParams();
            setGlobalParamsDone(true);
        }
    },[deviceObjects]);

    useEffect(() => {
        updateFiltersWithGlobalParams()
    }, [globalParams]);

    function compare(a, b) {
        if (a.description < b.description) {
            return -1;
        }
        if (a.description > b.description) {
            return 1;
        }
        return 0;
    }
    const getUnits = () => {
        setUnitsLoading(true);
        mdcApi
            .fetchUnits({ header: selectedDescription.description})
            .then((res) => {
                updateUnits(res);
                updateSelectedUnit(res[0])
                setUnitsLoading(false);
            })
            .catch((error) => {
                setUnitsLoading(false);
                alert("Error happened while trying to fetch units");
            });
    }
 
    const fetchDescriptions = (signal: any) => {
        if (customer == null && selectedDeviceTypes.length == 0 && allDescriptions.length > 0) {
            updateDescriptions(allDescriptions);
            updateDescriptionsOG(allDescriptions);
        }
        else {
            updateSelectedDescription(null);
            updateHeaderLoadingState(true);
            let customerID: string = Format.customerIDByCustomerName(deviceObjects, customer);
            let deviceIDs: any = Format.DeviceIDsByDeviceType(deviceObjects, selectedDeviceTypes)
            Api.fetchUniqueHeaders({ terms: { customerID: customerID, deviceTypes: deviceIDs } }, signal)
                .then((response: any) => {
                    if (response != "canceled") {
                        if (customerID == null && deviceIDs.length == 0) {
                            updateAllDescriptions(response.sort(compare));
                        }
                        updateDescriptionsOG(response.sort(compare));
                        updateDescriptions(response.sort(compare));
                        updateHeaderLoadingState(false);
                    }

                })
                .catch((error) => {


                    if (error.message != "canceled") {
                        updateHeaderLoadingState(false);
                        // setErrorMessage("Oops something went wrong, unable to get data.");
                    }
                    console.log(error);
                });
        }
    }


    const updateDropDowns = function () { 
        updateCountries(Format.Countries(deviceObjects));
        updateCustomers(Format.Customers(deviceObjects, null));
        updateDeviceTypes(Format.DeviceTypesByCountry(deviceObjects,null))
    };

    const checkDeviceCustomers = ():string[] => {
        let firstCustomer:string = null;
        let validDevices:string[] = [];
        if(globalParams.customerID !== null){
            const customerName = Format.customerByCustomerID(deviceObjects,globalParams.customerID);
            const customerDevices = Format.DevicesWithSerial(deviceObjects,customerName);
            validDevices = globalParams.devicesWithSerial.filter((item)=>customerDevices.includes(item))
        }else{
            const firstDevice = globalParams.devicesWithSerial[0];
            firstCustomer = Format.CustomerByDeviceWithSerial(deviceObjects,firstDevice)
            updateCustomer(firstCustomer);
            const customerDevices = Format.DevicesWithSerial(deviceObjects,firstCustomer);
            validDevices = globalParams.devicesWithSerial.filter((item)=>customerDevices.includes(item))
        }
        return validDevices;
    }

    const updateFiltersWithGlobalParams = () => {
     
        if (deviceObjects != null){   
            if(globalParams.country != country){
                
                updateCountry(globalParams.country)
                if(urlParamsDone === false){
                    if(!(globalParams.country === null || globalParams.country === "all" && country === null || country === "all"))
                    countryFilters(globalParams.country);
                }
            }

            const deviceTypeIDs = Format.DeviceIDsByDeviceType(deviceObjects,selectedDeviceTypes)
            if (globalParams.deviceTypes.length > 0 && !isEqual(globalParams.deviceTypes,deviceTypeIDs)){
                const deviceTypeStrings = Format.DeviceTypesByDeviceIDs(deviceObjects,globalParams.deviceTypes)
                updateDeviceTypes(Format.DeviceTypesByCountry(deviceObjects,globalParams.country))
                updateSelectedDeviceTypes(deviceTypeStrings)
                deviceTypesFilters(deviceTypeStrings)
            }

            const obj = deviceObjects.find(o => o.customerName === customer);

            if (obj){
                if(globalParams.customerID != obj.customerID){
                    updateCustomer(Format.customerByCustomerID(deviceObjects,globalParams.customerID))
                    customerFilters(Format.customerByCustomerID(deviceObjects,globalParams.customerID))
                }
            }else if(globalParams.customerID){
                updateCustomer(Format.customerByCustomerID(deviceObjects,globalParams.customerID))
                customerFilters(Format.customerByCustomerID(deviceObjects,globalParams.customerID))
            }

            if (!isEqual(globalParams.devicesWithSerial,selectedDevicesWithSerial)){
                updateSelectedDevicesWithSerial(checkDeviceCustomers());
                const customerStrings = Format.customerByCustomerID(deviceObjects,globalParams.customerID)
                updateDevicesWithSerial(Format.DevicesWithSerial(deviceObjects,customerStrings))
            }
        }
    }

    const updateFiltersWithUrlParams = () => {
        let tempCustomer: string;
        if (urlParams.customerid==null){
            tempCustomer = Format.CustomerByCadID(deviceObjects, urlParams.cadid)
        }else{
            tempCustomer = Format.customerByCustomerID(deviceObjects,urlParams.customerid)
        }

        const tempDevice = Format.DeviceWithSerialByCADID(deviceObjects,urlParams.cadid)
        const tempDevicesWithSerial = Format.DevicesWithSerial(deviceObjects, tempCustomer)
        if (urlParams.assembly != null) {
            updateSelectedAssembly(urlParams.assembly)
        }
        if (urlParams.component != null) {
            updateSelectedComponent(urlParams.component)
        }
        if (urlParams.description != null) {
            updateSelectedDescription(urlParams.description)
        }
        updateSelectedDevicesWithSerial(tempDevice)
        updateDevicesWithSerial(tempDevicesWithSerial)
        
        updateCustomer(tempCustomer)
        updateDeviceTypes(Format.DeviceTypesByCountry(deviceObjects,null))
    }

    //called on filter update
    const paramsHandler = () => {
        if (selectedDescription != null) {
            if (selectedUnit != null) {


                let params: any = {};
                params.terms = {};
                //params.start = formatDate(start);
                //params.end = formatDate(end);
                params.terms.deviceTypes = Format.DeviceIDsByDeviceType(deviceObjects, selectedDeviceTypes);
                //  params.devicesWithSerial = selectedDevicesWithSerial;

                //if(customer !== null){
                //    const obj = deviceObjects.find(o => o.customerName === customer);
                //    if (obj){
                //        params.customerID = obj.customerID;
                //    }
                //}else{
                //    params.customerID = null;
                //}
                if (country === null) {
                    params.terms.country = "all"
                } else {
                    params.terms.country = country
                }
                params.terms.customerID = Format.customerIDByCustomerName(deviceObjects, customer);
                params.terms = JSON.stringify(params.terms);
                params.header = selectedDescription.description;
                params.unit = selectedUnit;
                // params.alarmText = globalParams.alarmText
                //params.scope = determineScope(scopeOrder,customer,selectedDeviceTypes,selectedDevicesWithSerial)
                //  params = clearHiddenParams(params)

                //
                //
                props.updateParams(params);
            }
            else {alert("Please select a unit") }
        }
        else {

        alert("Please select a header")}
    };

    const clearHiddenParams = (params:Params) => {
        if(props.countryInput === false){
            params.country = null;
        }
        if(props.customerInput === false){
            params.customerID = null;
        }
        if(props.deviceTypeInput === false){
            params.deviceTypes = [];
        }
        if(props.deviceWithSerialInput === false){
            params.devicesWithSerial = [];
        }
        
      //  params.scope = determineScope(scopeOrder,params.country,params.customerID,params.deviceTypes,params.devicesWithSerial)
        
        
        return params;
    }

    const checkRequiredParams = () =>{
        if(props.deviceWithSerialInput === "required"){
            if(selectedDevicesWithSerial.length < 1){
                //alert("customer device required")
                return false;
            }
        }
        if(props.deviceTypeInput === "required"){
            if(selectedDeviceTypes.length < 1){
                //alert("device type required")
                return false; 
            }
        }
        if(props.countryInput === "required"){
            if(country === null){
                //alert("country required")
                return false; 
            }
        }
        if(props.customerInput === "required"){
            if(customer === null){
                //alert("customer required")
                return false;
            }
        }
        return true
    }

    const countryFilters = (country:string) => {
        
        if(scopeOrder !== "Device Type > Country > Customer > Machine"){
            updateSelectedDeviceTypes([]);
        }
        updateCustomer(null);
        updateSelectedDevicesWithSerial([]);
        //
        updateCustomers(Format.Customers(deviceObjects, country));
        updateDeviceTypes(Format.DeviceTypesByCountry(deviceObjects,country))
    }

    const customerFilters = (customer:string) =>{
        
        if(props.devicesFromMultipleCustomers === false){
            updateSelectedDevicesWithSerial([]);
        }
        updateDevicesWithSerial(Format.DevicesBySelectedTypes(deviceObjects,selectedDeviceTypes,customer))
    }

    const deviceTypesFilters = (devicetypes:any) =>{
        updateSelectedDevicesWithSerial([]);
        updateCustomer(null)
        updateDevicesWithSerial(Format.DevicesBySelectedTypes(deviceObjects,devicetypes,customer))
        
        updateCustomers(Format.customersByDeviceTypeAndCountry(deviceObjects,devicetypes,country))
    }

    const countryHandler = function (e: ComboBoxChangeEvent) {
        updateCountry(e.target.value);
        countryFilters(e.target.value)
    };

    const customerHandler = function (e: ComboBoxChangeEvent) {
        updateCustomer(e.target.value);
        customerFilters(e.target.value)
    };

    const deviceTypeHandler = (event:MultiSelectChangeEvent) =>{
        updateSelectedDeviceTypes([...event.value])
        deviceTypesFilters([...event.value])
    }

    const deviceWithSerialHandler = (event: MultiSelectChangeEvent) =>{
        
        updateSelectedDevicesWithSerial([...event.value])
    }
    const assemblyHandler = function (e: ComboBoxChangeEvent) {
        updateSelectedAssembly(e.target.value);
        updateSelectedComponent(null);
        updateSelectedDescription(null);
    };
    const componentHandler = function (e: ComboBoxChangeEvent) {
        updateSelectedComponent(e.target.value);
  
        updateSelectedDescription(null);
    };
    const descriptionHandler = function (e: ComboBoxChangeEvent) {
      
        updateSelectedDescription(e.value);
    };



    const scopeHandler = (e: ComboBoxChangeEvent) =>{
        setDialogVisible(!dialogVisible)
        
        updateScopeOrder(e.target.value)
    }

    const dialogCancel = () => {
        updateScopeOrder(options.scopeOrder)
        setDialogVisible(!dialogVisible)
    }

    const dialogConfirm = () =>{
        setDialogVisible(!dialogVisible)
        dispatch(updateOptionsScopeOrder(scopeOrder))
        resetFilters()
    }

    const resetFilters = () => {
        updateCountry(null)
        updateCustomer(null)
        updateSelectedDeviceTypes([])
        updateSelectedDevicesWithSerial([]);
        updateSelectedUnit(null);
        updateSelectedDescription(null);
        updateDropDowns()
        const resetValues: Params = {
            bucketSize:"y",
            calendarSize:"Year",
            start:formatDate(start),
            end:formatDate(end),
            country:"all",
            customerID:null,
            deviceTypes:[],
            devicesWithSerial: [],
            cadid:null,
            alarmText:null,
            scope: determineScope(scopeOrder,null,null,[],[]),
        };
        dispatch(updateParams(resetValues))
    }
    


    const formatDate = (d: any) => {
        var year = d.getFullYear();
        var month = d.getMonth() + 1;
        var day = d.getDate();
        if (month < 10) month = "0" + month;
        if (day < 10) day = "0" + day;
        return year + "-" + month + "-" + day;
    };

    const formatBucketSize = (bs: string) => {
        if (bs == "Year") return "y";
        if (bs == "Month") return "M";
        if (bs == "Week") return "w";
        if (bs == "Day") return "d";
    };

    const lastDayOfMonth = (date:Date) =>{
        const last = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        
        return last;
    }

    const lastDayOfYear = (date:Date) =>{
        const last = new Date(date.getFullYear(),11,31)
        if(last > new Date()){
            return new Date();
        }
        return last
    }
    /*
    const getBucketSize = () => {
        let dateRange = end.getTime() - start.getTime();
        dateRange = dateRange / (1000 * 60 * 60 * 24);
        let newBucketSize = bucketSize;
        if (newBucketSize === "Day") {
            if (dateRange > 60) {
                newBucketSize = "Week";
            }
        }
        if (newBucketSize === "Week") {
            if (dateRange > 185) {
                newBucketSize = "Month";
            }
        }
        if (newBucketSize === "Month") {
            if (dateRange > 730) {
                newBucketSize = "Year";
            }
        }
        if (newBucketSize != bucketSize) updateBucketSize(newBucketSize);
        return formatBucketSize(newBucketSize);
    };*/

    const comboBoxFilters = () => {
        return {
            countries: (event: ComboBoxFilterChangeEvent) => {
                //
                updateCountries(
                    filterBy(Format.Countries(deviceObjects), 
                    event.filter)
                );
            },
            customers: (event: ComboBoxFilterChangeEvent) => {
                //
                updateCustomers(
                    filterBy(
                        Format.Customers(deviceObjects, country),
                        event.filter
                    )
                );
            },
            headers: (event: ComboBoxFilterChangeEvent) => {
                //
                updateDescriptions(
                    filterBy(
                       descriptionsOG,
                        event.filter
                    )
                );
            },
        };
    };

    const multiSelectFilters = () =>{
        return {
            deviceTypes:(event: MultiSelectFilterChangeEvent)=>{
                //
                updateDeviceTypes(
                    filterBy(Format.DeviceTypesByCountry(deviceObjects,country),
                    event.filter
                    )
                )
            },
            devicesWithSerial:(event: MultiSelectFilterChangeEvent)=>{
                //
                updateDevicesWithSerial(
                    filterBy(
                        Format.DevicesWithSerial(deviceObjects,customer),
                        event.filter
                    )
                )
            }
        }
    }

    const renderDateInputs = () => {
         return (
                <Fragment>
                    {" "}
                    <div className="k-textbox-container metricCombo">
                        <label className="k-label">Start</label>
                        <DatePicker
                            value={start}
                            onChange={(e) =>
                                e.target.value && setStart(e.target.value)
                            }
                            format={"dd.MM.yyyy"}
                        />
                    </div>
                    <div className="k-textbox-container metricCombo">
                        <label className="k-label">End</label>
                        <DatePicker
                            value={end}
                            onChange={(e) =>
                                e.target.value && setEnd(e.target.value)
                            }
                            format={"dd.MM.yyyy"}
                        />
                    </div>
                </Fragment>
            );
        
 
    };

    
    const renderDeviceWithSerialInput = () =>{
        if ((customer !== null  && props.deviceWithSerialInput === "hidden") || props.deviceWithSerialInput === true || props.deviceWithSerialInput === "required"){
            
            
            return (
                <div className=" k-textbox-container metricCombo">
                    <label className="k-label" style={{ width: "300px" }}>
                        Customer Device
                    </label>
                        <MultiSelect
                            popupSettings={{width:"auto"}} 
                            data={devicesWithSerial}
                            value={selectedDevicesWithSerial}
                            onChange={deviceWithSerialHandler}
                            filterable={true}
                            onFilterChange={multiSelectFilters().devicesWithSerial}
                            autoClose={false}
                        />
                </div>
            );
        }
        return <></>
    }



    const renderCountryInput = () => {
        if(props.countryInput === true || "required"){
            return (
                <div className=" k-textbox-container metricCombo">
                    <label className="k-label">Country</label>
                    <ComboBox
                        popupSettings={{width:"auto"}}
                        data={countries}
                        value={country}
                        onChange={countryHandler}
                        suggest={true}
                        filterable={true}
                        onFilterChange={comboBoxFilters().countries}
                    />
                </div>
            )
        }else{
            return null;
        }
    }


    const renderCustomerInput = () => {
        if (props.customerInput === true || "required"){
            return (
                <div className=" k-textbox-container metricCombo">
                    <label className="k-label">Customer</label>
                    <ComboBox
                        popupSettings={{width:"auto"}}
                        data={customers}
                        value={customer}
                        onChange={customerHandler}
                        suggest={true}
                        filterable={true}
                        onFilterChange={comboBoxFilters().customers}
                    />
                </div>
            )
        }else{
            return null;
        }
    }

    const renderDeviceTypeInput = () => {
        if(props.deviceTypeInput === true || "required"){
            return (
                <div className=" k-textbox-container metricCombo">
                    <label className="k-label" style={{ width: "300px" }}>
                        Device Type
                    </label>
                    <MultiSelect
                        popupSettings={{width:"auto"}} 
                        data={deviceTypes}
                        value={selectedDeviceTypes}
                        onChange={deviceTypeHandler}
                        filterable={true}
                        onFilterChange={multiSelectFilters().deviceTypes}
                        autoClose={false}
                    />
                </div>
            )
        }else{
            return null;
        }

    }
    const renderPartWearOutFilters = () => {
        return (<>
      
             <div className=" k-textbox-container metricCombo">
                <label className="k-label">Header</label>
                <ComboBox
                    popupSettings={{ width: "auto" }}
                    data={descriptions}
                    value={selectedDescription}
                    onChange={descriptionHandler}
                    suggest={true}
                    filterable={true}
                    dataItemKey={'description'}
                    textField={"description"}
                    onFilterChange={comboBoxFilters().headers}
                    loading={headerLoadingState}
                   // onFilterChange={comboBoxFilters().customers}
                />
            </div>
        </>
        )
    }
    const renderUnits = () => {
        return (
            <div className=" k-textbox-container metricCombo">
                <label className="k-label">Unit</label>
                <DropDownList
                    data={units}
                    value={selectedUnit}
                    onChange={(e) => updateSelectedUnit(e.target.value)}
                    loading={unitsLoading}
                />
            </div>
            )
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////

    function renderContent() {
        if (deviceLoadState == "pending") {
            return (
                <div style={{ width: "100%" }}>
                    <Spinner text="devices" />
                </div>
            );
        }
        if (deviceLoadState == "rejected") {
            return <div>Oops something went wrong.</div>;
        }
       
        return (
            <Fragment>
                {renderCountryInput()}
                {renderDeviceTypeInput()}
                {renderCustomerInput()}
                {renderPartWearOutFilters()}
                {renderUnits() }
                <div className="k-textbox-container metricCombo">
                    <Button
                        className=" pp-filter-button"
                        onClick={paramsHandler}
                        >
                        UPDATE
                    </Button>
                </div>
                <Button
                    className=" pp-filter-button"
                    onClick={resetFilters}
                >
                    Reset Filters
                </Button>
                    
            </Fragment>
        );
    }

    return <Fragment>{renderContent()}</Fragment>;
};

Filters.defaultProps = {
    countryInput:true,
    deviceTypeInput:true,
    customerInput:true,
    deviceWithSerialInput:true,
    scopeOrderInput:false,
    groupByInput:false,
    devicesFromMultipleCustomers:false
};

export default Filters;
